import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const routes = [
    {path: '/', name: 'home', component: () => import('../components/home')},
    {
        path: '/admin',
        name: 'admin',
        component: () => import('../components/admin/index'),
        children: [
            {path: 'home',component: () => import('../components/admin/home')},
            {
                path: 'product/list',
                component: () => import('../components/admin/product/list')
            },
            {
                path: 'product/edit',
                component: () => import('../components/admin/product/edit')
            },
            {
                path: 'order/list',
                component: () => import('../components/admin/order/list')
            },
            {
                path: 'order/view',
                component: () => import('../components/admin/order/view')
            },
            {
                path: 'order/delivery',
                component: () => import('../components/admin/order/delivery')
            },
            {
                path: 'store/edit',
                component: () => import('../components/admin/store/edit')
            },
            {
                path: 'money/index',
                component: () => import('../components/admin/money/index')
            },
            {
                path: 'money/withdraw',
                component: () => import('../components/admin/money/withdraw')
            },
            {
                path: 'money/bank',
                component: () => import('../components/admin/money/bank')
            },
            {path:'cashier',component: () => import('../components/admin/cashier')},
            {path:'stock/in',component: () => import('../components/admin/stock/in')},
            {path:'stock/out',component: () => import('../components/admin/stock/out')},
            {path:'booking/list',component: () => import('../components/admin/booking/list')},
          {path:'booking/item-create',component: () => import('../components/admin/booking/item-create')},
          {path:'booking/item-list',component: () => import('../components/admin/booking/item-list')},
            {path:'member/list',component: () => import('../components/admin/member/list')},
            {path:'member/edit',component: () => import('../components/admin/member/edit')},
            {path:'member/add-card',component: () => import('../components/admin/member/add-card')},
            {path:'member/detail',component: () => import('../components/admin/member/detail')},
            {path:'member/recharge',component: () => import('../components/admin/member/recharge')},

            {path:'category/list',component: () => import('../components/admin/category/list')},
            {path:'category/edit',component: () => import('../components/admin/category/edit')},
            {path:'setting/product-unit',component: () => import('../components/admin/setting/product-unit')},
            {path:'statistic/customer',component: () => import('../components/admin/statistic/customer')},
            {path:'statistic/customer-consume',component: () => import('../components/admin/statistic/customer-consume')},
            {path:'statistic/customer-recharge',component: () => import('../components/admin/statistic/customer-recharge')}
        ]
    },
    {path: '/admin/login',component: () => import('../components/admin/login')},
    {path: '/admin/reg',component: () => import('../components/admin/reg')},
    {path: '/admin/find-password',component: () => import('../components/admin/find-password')},


    {path: '/mobile', component: () => import('../components/mobile/index')},
    {path: '/mobile/index', component: () => import('../components/mobile/index')},
    {path: '/mobile/store/index', component: () => import('../components/mobile/store/index')},
    {
        path: '/mobile/store/edit',
        component: () => import('../components/mobile/store/edit')
    },
    {
        path: '/mobile/product/list',
        component: () => import('../components/mobile/product/list')
    },
    {
        path: '/mobile/product/create',
        component: () => import('../components/mobile/product/create')
    },
    {
        path: '/mobile/order/list',
        component: () => import('../components/mobile/order/list')
    },
    {
        path: '/mobile/member/index',
        component: () => import('../components/mobile/member/index')
    },
    {
        path: '/mobile/money/index',
        component: () => import('../components/mobile/money/index')
    },
    {path: '/mobile/money/recharge',component: () => import('../components/mobile/money/recharge')},
    {
        path: '/mobile/money/withdraw',
        component: () => import('../components/mobile/money/withdraw')
    },
    {path: '/mobile/money/adjustment', component: () => import('../components/mobile/money/adjustment')},
    {
        path: '/mobile/market/index',
        component: () => import('../components/mobile/market/index')
    },
    {
        path: '/mobile/statistic/income',
        component: () => import('../components/mobile/statistic/income')
    },
    {
        path: '/mobile/statistic/flow',
        component: () => import('../components/mobile/statistic/flow')
    },
    {
        path: '/mobile/statistic/order',
        component: () => import('../components/mobile/statistic/order')
    },
    {
        path: '/mobile/statistic/customer',
        component: () => import('../components/mobile/statistic/customer')
    }, {
        path: '/mobile/order/view',
        component: () => import('../components/mobile/order/view')
    }, {
        path: '/mobile/member/search',
        component: () => import('../components/mobile/member/search')
    }, {
        path: '/mobile/group/index',
        component: () => import('../components/mobile/group/index')
    }, {
        path: '/mobile/fenxiao/index',
        component: () => import('../components/mobile/fenxiao/index')

    },
    {
        path: '/mobile/fenxiao/setting',
        component: () => import('../components/mobile/fenxiao/setting')
    },
    {
        path: '/mobile/fenxiao/order',
        component: () => import('../components/mobile/fenxiao/order')
    }, {
        path: '/mobile/fenxiao/rank',
        component: () => import('../components/mobile/fenxiao/rank')
    }, {
        path: '/mobile/fenxiao/withdraw',
        component: () => import('../components/mobile/fenxiao/withdraw')
    },
    {path: '/mobile/booking/index', component: () => import('../components/mobile/booking/index')},
    {path: '/mobile/booking/add', component: () => import('../components/mobile/booking/add')},
    {path: '/mobile/member/add', component: () => import('../components/mobile/member/add')},
    {path: '/mobile/member/detail', component: () => import('../components/mobile/member/detail')},
    {path: '/mobile/member/consume-detail',component: () => import('../components/mobile/member/consume-detail')},
    {path: '/mobile/member/card-index', component: () => import('../components/mobile/member/card-index')},
    {path: '/mobile/member/card-bill', component: () => import('../components/mobile/member/card-bill')},
    {path: '/mobile/member/integral-adjust', component: () => import('../components/mobile/member/integral-adjust')},
    {path: '/mobile/member/integral-exchange', component: () => import('../components/mobile/member/integral-exchange')},
    {path: '/mobile/card/add', component: () => import('../components/mobile/card/add')},
    {path: '/mobile/card/list', component: () => import('../components/mobile/card/list')},
    {path: '/mobile/card/member-add', component: () => import('../components/mobile/card/member-add')},
    {path: '/mobile/cashier', component: () => import('../components/mobile/cashier')},
    {path: '/mobile/statistic/index', component: () => import('../components/mobile/statistic/index')},
    {path: '/mobile/statistic/recharge', component: () => import('../components/mobile/statistic/recharge')},
    {path: '/mobile/category/list', component: () => import('../components/mobile/category/list')},
    {path: '/mobile/category/edit', component: () => import('../components/mobile/category/edit')},
    {path: '/mobile/booking/item-add', component: () => import('../components/mobile/booking/item-add')},
    {path: '/mobile/booking/item-index', component: () => import('../components/mobile/booking/item-index')},
    {path: '/mobile/customer/index', component: () => import('../components/mobile/customer/index')},
    {path: '/mobile/customer/card-detail', component: () => import('../components/mobile/customer/card-detail')},
    {path: '/mobile/customer/bill', component: () => import('../components/mobile/customer/bill')},
    {path: '/mobile/customer/my', component: () => import('../components/mobile/customer/my')},

    {path: '/mobile/statistic/store-operate', component: () => import('../components/mobile/statistic/store-operate')},
    {path: '/mobile/statistic/consume', component: () => import('../components/mobile/statistic/consume')},
    {path: '/mobile/statistic/product-consume', component: () => import('../components/mobile/statistic/product-consume')},
    {path: '/mobile/statistic/member-stat', component: () => import('../components/mobile/statistic/member-stat')},
    {path: '/mobile/statistic/integral-stat', component: () => import('../components/mobile/statistic/integral-stat')},
    {path: '/mobile/statistic/reg-stat', component: () => import('../components/mobile/statistic/reg-stat')},
    {path: '/mobile/stock/index', component: () => import('../components/mobile/stock/index')},
    {path: '/mobile/stock/in', component: () => import('../components/mobile/stock/in')},
    {path: '/mobile/stock/out', component: () => import('../components/mobile/stock/out')},
    {path: '/mobile/stock/detail', component: () => import('../components/mobile/stock/detail')},
    {path: '/mobile/login', component: () => import('../components/mobile/login')},
    {path: '/mobile/reg', component: () => import('../components/mobile/reg')},
    {path: '/mobile/find-password', component: () => import('../components/mobile/find-password')}

]
const router = new VueRouter({
    mode: 'hash',
    base: __dirname,
    routes
})

router.beforeEach((to, from, next) => {
        if (to.query.access_token && to.query.user_id) {
            Cookies.set('access_token', to.query.access_token,{expires:7});
            Cookies.set('user_id', to.query.user_id,{expires:7});
            next();
        } else {
            var access_token = Cookies.get('access_token');
            //如果access_token不存在
            if (!access_token) {
                let screenWidth = window.screen.width;
                if (screenWidth > 800) {
                    if (to.path == '/admin/login' || to.path == '/admin/reg' || to.path == '/admin/find-password') {
                        next();
                    }else {
                        //电脑端
                        next({path:'/admin/login'})
                    }
                } else {
                    if (to.path == '/mobile/login' || to.path == '/mobile/reg' || to.path == '/mobile/find-password') {
                        next();
                    }else {
                        //手机端
                        next({path:'/mobile/login?redirectUrl='+encodeURIComponent(location.href)})
                    }
                }
            } else {
                //access_token存在
                next();
            }
        }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js